export const FACTURAS = {
    URL: 'Services/Invoicing/',
    FACTURACION_MANUAL: {
        CreateDirectInvoiceSimulated: 'SalesInvoicesService.svc/CreateDirectInvoiceSimulated',
        CreateDirectInvoice: 'SalesInvoicesService.svc/CreateDirectInvoice'
    },
    FACTURA_ELECTRONICA: {
        GetAllInvoiceE: 'InvoiceEService.svc/GetAllInvoiceE',
        GetInvoiceByIdComplete: 'SalesInvoicesService.svc/GetInvoiceByIdComplete',
        DeleteInvoiceE: 'InvoiceEService.svc/DeleteInvoiceE',
        GetAll: 'SalesInvoicesService.svc/GetAll',
        FindByRoleReceptor: 'AdministrativeCenterService.svc/FindByRoleReceptor',
        FindByRoleFiscal: 'AdministrativeCenterService.svc/FindByRoleFiscal',
        FindByRoleBuyer: 'AdministrativeCenterService.svc/FindByRoleBuyer',
        FindByRolePayer: 'AdministrativeCenterService.svc/FindByRolePayer',
        ExportInvoice: 'InvoiceEService.svc/ExportInvoice',
        UpdateAdministrativeCenters: 'CustomerService.svc/UpdateCustomerAdministrativeCenters'
    },
    RECIBOS_VENCIMIENTOS: {
        FindPaymentCharges: 'PaymentChargesService.svc/FindPaymentCharges',
        EffectTypesService: 'EffectTypesService.svc/GetAll',
        GetPaymentChargeById: 'PaymentChargesService.svc/GetPaymentChargeById',
        GetInvoiceByIdWithDetails: 'SalesInvoicesService.svc/GetInvoiceByIdWithDetails',
        InvoicePaymentPending: 'SalesInvoicesService.svc/InvoicePaymentPending',
        GetAllInvoicePaymentPending: 'SalesInvoicesService.svc/GetAllInvoicePaymentPending',
        GetAll: 'InvoicePaymentsService.svc/GetAll',
        GetInvoiceByIdComplete: 'SalesInvoicesService.svc/GetInvoiceByIdComplete',
        GetInvoicePaymentHeaderByID: 'InvoicePaymentsService.svc/GetInvoicePaymentHeaderByID'

    },
    REMESAS: {
        GetAllBanks: 'BankService.svc/GetAllBanks',
        FindRemittanceCharges: 'RemittanceService.svc/FindRemittanceCharges',
        GetRemittanceChargeById: 'RemittanceService.svc/GetRemittanceChargeById',
        GetRemittanceBankByRemittanceChargeId: 'RemittanceService.svc/GetRemittanceBankByRemittanceChargeId',
        CreditRemittanceCharge: 'RemittanceService.svc/CreditRemittanceCharge',
        CreditPaymentCharge: 'RemittanceService.svc/CreditPaymentCharge',
        CancelRemittanceCreditById: 'RemittanceService.svc/CancelRemittanceCreditById',
        CancelRemittanceCharge: 'RemittanceService.svc/CancelRemittanceCharge',
        CancelRemittanceBank: 'RemittanceService.svc/CancelRemittanceBank'
    },
    LIBRETA: {
        urlGetInvoiceDraftAll: 'Services/Invoicing/InvoiceDraftsService.svc/GetAll',
        urlGetDraftByIdWithDetails: 'Services/Invoicing/InvoiceDraftsService.svc/GetDraftByIdWithDetails',
        urlDeleteDraftById: 'Services/Invoicing/InvoiceDraftsService.svc/DeleteDraftById',
        urlGetNewDocumentNumber: 'Services/Invoicing/InvoiceDraftsService.svc/GetNewDocumentNumber',
        urlCreateDraftByParams: 'Services/Invoicing/InvoiceDraftsService.svc/CreateDraftByParams',
        urlUpdateDraft: 'Services/Invoicing/InvoiceDraftsService.svc/UpdateDraftCustomer',
        urlAddDraftDetail: 'Services/Invoicing/InvoiceDraftsService.svc/AddDraftDetail',
        urlUpdateDraftDetail: 'Services/Invoicing/InvoiceDraftsService.svc/UpdateDraftDetail',
        urlDeleteDraftDetail: 'Services/Invoicing/InvoiceDraftsService.svc/DeleteDraftDetailById',
        urlGetAllTypesPayment: 'Services/General/PaymentTypesService.svc/GetAll',
        urlUpdateDraftSave: 'Services/Invoicing/InvoiceDraftsService.svc/UpdateDraft',
        urlSimulateUpdateDraft: 'Services/Invoicing/InvoiceDraftsService.svc/SimulateUpdateDraft',
        urlGetInvoicingEnumerationView: 'Services/General/DocumentsEnumerationService.svc/GetInvoicingEnumerationView',
        urlBillDraftByInvoiceID: 'Services/Invoicing/InvoiceDraftsService.svc/BillDraftByInvoiceID'
    },
    FACTURAS_RECIBIDAS: {
        GetInProgressInvoices: 'Services/Invoicing/PurchaseInvoicesService.svc/GetInProgressInvoices',
        GetSuppliersWithPendingEntries: 'Services/Invoicing/PurchaseInvoicesService.svc/GetSuppliersWithPendingEntries',
        GetVOInvoices: 'Services/Invoicing/PurchaseInvoicesService.svc/GetVOInvoices',
        GetVOTransfers: 'Services/Invoicing/PurchaseInvoicesService.svc/GetVOTransfers',
        GetBilledInvoices: 'Services/Invoicing/PurchaseInvoicesService.svc/GetBilledInvoices',
        GetInvoiceByIdWithDetails: 'Services/Invoicing/PurchaseInvoicesService.svc/GetInvoiceByIdWithDetails',
        FindMaterialEntriesForInvoicing: 'Services/Invoicing/PurchaseInvoicesService.svc/FindMaterialEntriesForInvoicing',
        AddInvoiceDetailByParams: 'Services/Invoicing/PurchaseInvoicesService.svc/AddInvoiceDetailByParams',
        UpdateInvoiceDetailByParams: 'Services/Invoicing/PurchaseInvoicesService.svc/UpdateInvoiceDetailByParams',
        DeleteInvoiceDetailById: 'Services/Invoicing/PurchaseInvoicesService.svc/DeleteInvoiceDetailById',
        CreatePurchaseInvoice: 'Services/Invoicing/PurchaseInvoicesService.svc/CreatePurchaseInvoice',
        MaterialEntryInvoicingSimulation: 'Services/Invoicing/PurchaseInvoicesService.svc/MaterialEntryInvoicingSimulation',
        UpdatePurchaseInvoiceByParams: 'Services/Invoicing/PurchaseInvoicesService.svc/UpdatePurchaseInvoiceByParams',
        GetAllPayment: 'Services/General/PaymentTypesService.svc/GetAll',
        GetAllVAT: 'Services/General/VatTypeService.svc/GetAll',
        DeletePurchaseInvoiceByParams: 'Services/Invoicing/PurchaseInvoicesService.svc/DeletePurchaseInvoiceByParams',
        FinishPurchaseInvoice: 'Services/Invoicing/PurchaseInvoicesService.svc/FinishPurchaseInvoice',
        CreateCorrectivePurchaseInvoice: 'Services/Invoicing/PurchaseInvoicesService.svc/CreateCorrectivePurchaseInvoice',
        GetInvoiceByNumberWithDetails: 'Services/Invoicing/PurchaseInvoicesService.svc/GetInvoiceByNumberWithDetails',
        GetVOInvoicesAndTransfers: 'Services/Invoicing/PurchaseInvoicesService.svc/GetVOInvoicesAndTransfers',
        CreatePurchaseInvoiceByParams: 'Services/Invoicing/PurchaseInvoicesService.svc/CreatePurchaseInvoiceByParams'
    },
    HOME: {
        GetBilledRepairOrdersOfLastTwoMonths: 'Services/Workshop/WorkshopHomeService.svc/GetBilledRepairOrdersOfLastTwoMonths',
        GetDailyInvoices: 'Services/Invoicing/SalesInvoicesService.svc/GetDailyInvoices',
        GetClosedRepairOrders: 'Services/Invoicing/HomeInvoicesService.svc/GetClosedRepairOrders'
    },
    FACTURACION_MASIVA: {
        GetDailyInvoices: 'Services/Invoicing/SalesInvoicesService.svc/GetInvoicesWithDetails',
    },
    FACTURA_TBAI: {
        GetAllTBAI: 'Services/Invoicing/TicketBAIService.svc/GetAllTicketBAI',
        GetAllZuzendu: 'Services/Invoicing/TicketBAIService.svc/GetAllZuzendu',
        GetById: 'Services/Invoicing/TicketBAIService.svc/GetTicketBAIById',
        GetTBAIWithoutSGById: 'Services/Invoicing/BatuzService.svc/GetTBAIWithoutSGById',
        GetByIdZuzendu: 'Services/Invoicing/TicketBAIService.svc/GetZuzenduById',
        CanSend: 'Services/Invoicing/TicketBAIService.svc/CanSend',
        CanCancel: 'Services/Invoicing/TicketBAIService.svc/CanCancel',
        CanCancelSG: 'Services/Invoicing/BatuzService.svc/CanCancelTBAIWithoutSG',
        Send: 'Services/Invoicing/TicketBAIService.svc/SendExportedInvoice',
        SendV2: 'Services/Invoicing/TicketBAIService.svc/SendInvoices',
        SendAllPending: 'Services/Invoicing/TicketBAIService.svc/SendAllPendingToSendInvoices',
        Cancel: 'Services/Invoicing/TicketBAIService.svc/CancelInvoice',
        GetNotReceivedTBAIWithoutSG: 'Services/Invoicing/BatuzService.svc/GetNotReceivedTBAIWithoutSG',
        SetSimplifiedInvoice: 'Services/Invoicing/TicketBAIService.svc/SetSimplifiedInvoice',
        GetZuzenduViewById: 'Services/Invoicing/TicketBAIService.svc/GetZuzenduViewById',
        CreateZuzenduFromTicketBAI: 'Services/Invoicing/TicketBAIService.svc/CreateZuzenduFromTicketBAI',
        CreateZuzenduFromZuzendu: 'Services/Invoicing/TicketBAIService.svc/CreateZuzenduFromZuzendu',
        SetSimplifiedSubstitutionAmendment: 'Services/Invoicing/TicketBAIService.svc/SetSimplifiedSubstitutionAmendment',
        SetAmendmentData: 'Services/Invoicing/TicketBAIService.svc/SetAmendmentData',
        GetAllAmendmentInvoiceCodes: 'Services/Invoicing/TicketBAIService.svc/GetAllAmendmentInvoiceCodes',
        GetAllAmendmentInvoiceType: 'Services/Invoicing/TicketBAIService.svc/GetAllAmendmentInvoiceType',
        SetAmendmentInvoice: 'Services/Invoicing/TicketBAIService.svc/SetAmendmentInvoice',
        DeleteAmendmentInvoice: 'Services/Invoicing/TicketBAIService.svc/DeleteAmendmentInvoice',
        SetInvoiceDescription: 'Services/Invoicing/TicketBAIService.svc/SetInvoiceDescription',
        GetAllVATRegimes: 'Services/Invoicing/TicketBAIService.svc/GetAllVATRegimes',
        SetVATRegime: 'Services/Invoicing/TicketBAIService.svc/SetVATRegime',
        UpdateDetails: 'Services/Invoicing/TicketBAIService.svc/UpdateDetails',
        SetBreakdown: 'Services/Invoicing/TicketBAIService.svc/SetBreakdown',
        SetTotals: 'Services/Invoicing/TicketBAIService.svc/SetTotals',
        GetAllNotExemptTypes: 'Services/Invoicing/TicketBAIService.svc/GetAllNotExemptTypes',
        SendZuzendu: 'Services/Invoicing/TicketBAIService.svc/SendExportedZuzendu',
        ResetZuzendu: 'Services/Invoicing/TicketBAIService.svc/UpdateZuzenduFromTicketBAI',
        ValidateZuzendu: 'Services/Invoicing/TicketBAIService.svc/ValidateZuzendu',
        ValidateXML: 'Services/Invoicing/TicketBAIService.svc/ValidateXmlZuzendu',
        SetCancelData: 'Services/Invoicing/TicketBAIService.svc/SetCancelData',
        EndTicketBAI: 'Services/Invoicing/TicketBAIService.svc/EndTicketBAI',
        RestoreTicketBAI: 'Services/Invoicing/TicketBAIService.svc/DeleteEndedTicketBAI',
        CreateAndSendBatuz: 'Services/Invoicing/BatuzService.svc/CreateAndSendBatuz',
        CreateAndSendBatuzWithoutSG: 'Services/Invoicing/BatuzService.svc/CreateAndSendBatuzWithoutSG',
        CreateTBAIWithoutSGFromTBAI: 'Services/Invoicing/BatuzService.svc/CreateTBAIWithoutSGFromTBAI',
        CreateTBAIWithoutSGFromTBAIWithoutSG: 'Services/Invoicing/BatuzService.svc/CreateTBAIWithoutSGFromTBAIWithoutSG',
        GetAllTicketBAIWithoutSG: 'Services/Invoicing/BatuzService.svc/GetAllTicketBAIWithoutSG',
        GetTBAIWithoutSGViewById: 'Services/Invoicing/BatuzService.svc/GetTBAIWithoutSGViewById',
        SetReceiverSG: 'Services/Invoicing/BatuzService.svc/SetReceiver',
        SetSimplifiedInvoiceSG: 'Services/Invoicing/BatuzService.svc/SetSimplifiedInvoice',
        SetSimplifiedSubstitutionAmendmentSG: 'Services/Invoicing/BatuzService.svc/SetSimplifiedSubstitutionAmendment',
        SetAmendmentDataSG: 'Services/Invoicing/BatuzService.svc/SetAmendmentData',
        SetAmendmentInvoiceSG: 'Services/Invoicing/BatuzService.svc/SetAmendmentInvoice',
        DeleteAmendmentInvoiceSG: 'Services/Invoicing/BatuzService.svc/DeleteAmendmentInvoice',
        SetInvoiceDescriptionSG: 'Services/Invoicing/BatuzService.svc/SetInvoiceDescription',
        SetVATRegimeSG: 'Services/Invoicing/BatuzService.svc/SetVATRegime',
        SetBreakdownSG: 'Services/Invoicing/BatuzService.svc/SetBreakdown',
        SetTotalsSG: 'Services/Invoicing/BatuzService.svc/SetTotals',
        SetCancelDataSG: 'Services/Invoicing/BatuzService.svc/SetCancelData',
        ValidateXMLSG: 'Services/Invoicing/BatuzService.svc/ValidateXMLTBAIWithoutSG',
        ValidateTBAIWithoutSG: 'Services/Invoicing/BatuzService.svc/ValidateTBAIWithoutSG',
        ResetTBAIWithoutSG: 'Services/Invoicing/BatuzService.svc/ResetTBAIWithoutSG',
        CreateCancelTBAIWithoutSGFromTBAIWithoutSG: 'Services/Invoicing/BatuzService.svc/CreateCancelTBAIWithoutSGFromTBAIWithoutSG',
        GetAllTicketBAICount: 'Services/Invoicing/TicketBAIService.svc/GetAllTicketBAICount',
        GetAllZuzenduCount: 'Services/Invoicing/TicketBAIService.svc/GetAllZuzenduCount',
        GetAllTicketBAIWithoutSGCount: 'Services/Invoicing/BatuzService.svc/GetAllTicketBAIWithoutSGCount',
        CanCreateTBAIWithoutSGChild: 'Services/Invoicing/BatuzService.svc/CanCreateTBAIWithoutSGChild',
        GetAllTBAIWithoutSGHistory: 'Services/Invoicing/BatuzService.svc/GetAllTBAIWithoutSGHistory',
        GetTBAIWithoutSGHistoryViewById: 'Services/Invoicing/BatuzService.svc/GetTBAIWithoutSGHistoryViewById',
    },
    BATUZ: {
        GetAllBatuz: 'Services/Invoicing/BatuzService.svc/GetAllBatuz',
        GetAllBatuzWithoutSG: 'Services/Invoicing/BatuzService.svc/GetAllBatuzWithoutSG',
        GetAllBatuzCount: 'Services/Invoicing/BatuzService.svc/GetAllBatuzCount',
        GetAllBatuzWithoutSGCount: 'Services/Invoicing/BatuzService.svc/GetAllBatuzWithoutSGCount',
        SendBatuz: 'Services/Invoicing/BatuzService.svc/SendBatuz',
        SendBatuzWithoutSG: 'Services/Invoicing/BatuzService.svc/SendBatuzWithoutSG',
        DeleteBatuz: 'Services/Invoicing/BatuzService.svc/DeleteBatuz',
        DeleteBatuzWithoutSG: 'Services/Invoicing/BatuzService.svc/DeleteBatuzWithoutSG',
        GetDetailTBAIFromBatuz: 'Services/Invoicing/BatuzService.svc/GetDetailTBAIFromBatuz',
        GetDetailTBAIWithoutSGFromBatuzWithoutSG: 'Services/Invoicing/BatuzService.svc/GetDetailTBAIWithoutSGFromBatuzWithoutSG'
    },
    AUTOFACTURAS: {
        CreateSelfInvoice: 'Services/Invoicing/SalesInvoicesService.svc/CreateSelfInvoice',
        GetNewDocumentNumber: 'Services/Invoicing/SalesInvoicesService.svc/GetNewDocumentNumber'
    }
};


